<template>
  <div class="uid-name">
    <span class="uid-name__id">{{ uid }}</span>
    <span class="uid-name__name">{{ name }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: [Number, String],
    required: true,
  },
  name: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
});

const uid = computed(() => {
  const hexId = Number(props.id).toString(16);
  return props.prefix ? `${props.prefix}-${hexId}` : hexId;
});
</script>

<style scoped>
.uid-name {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #f8f9fa;
  font-size: 16px;
  min-height: 36px;
}

.uid-name__id {
  font-weight: 600;
  font-family: monospace;
  font-size: 18px;
  color: #333333;
}

.uid-name__name {
  font-size: 16px;
  color: #555555;
  flex: 1;
}
</style>
